import type { ScalableProductCARD_STYLE_TYPE } from '../types';

export const defaultScalableStyle: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: true, isClickable: true },
    image: { isVisible: true },
    comparison: { isVisible: false },
    ids: { customerArticleNumber: true, articleNumber: true, ean: true },
    positionText: { isVisible: false },
    tags: { isVisible: true },
    icons: { isVisible: true },
    prices: {
        isVisible: true,
        uvp: { showUvpWithoutVat: false, showUvpWithVat: false },
        showSurcharges: false,
        showScalePrices: true
    },
    order: {
        quantityPicker: { isVisible: true, pickerDisabled: false, showCalculator: true, showCableSnap: true },
        showAddToCart: true,
        showSecondaryButton: true,
        showBestPrice: true,
        showPriceBadge: false,
        showPackagingSize: false
    },

    availabilities: { isVisible: true, showPickupChannels: true },
    additionalLinks: { isVisible: true },
    information: { isVisible: false }
};

export const cableSnapScalableStyle: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: true, isClickable: true },
    image: { isVisible: true },
    comparison: { isVisible: false },
    ids: { customerArticleNumber: false, articleNumber: true, ean: true },
    positionText: { isVisible: false },
    tags: { isVisible: true },
    icons: { isVisible: true },
    prices: {
        isVisible: true,
        uvp: { showUvpWithoutVat: true, showUvpWithVat: true },
        showSurcharges: false,
        showScalePrices: false
    },
    order: {
        quantityPicker: { isVisible: true, pickerDisabled: true, showCalculator: false, showCableSnap: false },
        showAddToCart: true,
        showSecondaryButton: false,
        showPriceBadge: false,
        showPackagingSize: false,
        showBestPrice: false
    },
    availabilities: { isVisible: false, showPickupChannels: true },
    additionalLinks: { isVisible: false },
    information: { isVisible: false }
};

export const cartScalableStyle: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: true, isClickable: true },
    image: { isVisible: true },
    comparison: { isVisible: false },
    ids: { customerArticleNumber: true, articleNumber: true, ean: true },
    positionText: { isVisible: true },
    tags: { isVisible: true },
    icons: { isVisible: true },
    prices: {
        isVisible: true,
        uvp: { showUvpWithoutVat: true, showUvpWithVat: true },
        showSurcharges: true,
        showScalePrices: true
    },
    order: {
        quantityPicker: { isVisible: true, pickerDisabled: false, showCalculator: true },
        showAddToCart: false,
        showSecondaryButton: true,
        showPriceBadge: true,
        showBestPrice: true,
        showPackagingSize: true
    },
    availabilities: { isVisible: true, showPickupChannels: true },
    additionalLinks: { isVisible: true },
    information: { isVisible: true }
};

export const checkoutScalableStyle: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: true, isClickable: true },
    image: { isVisible: true },
    comparison: { isVisible: false },
    ids: { customerArticleNumber: true, articleNumber: true, ean: true },
    positionText: { isVisible: false },
    tags: { isVisible: true },
    icons: { isVisible: true },
    prices: {
        isVisible: true,
        uvp: { showUvpWithoutVat: true, showUvpWithVat: true },
        showSurcharges: true,
        showScalePrices: true
    },
    order: {
        quantityPicker: { isVisible: true, pickerDisabled: true, showCalculator: false },
        showAddToCart: false,
        showSecondaryButton: false,
        showPriceBadge: true,
        showBestPrice: true,
        showPackagingSize: true
    },
    availabilities: { isVisible: true, showPickupChannels: true },
    additionalLinks: { isVisible: false },
    information: { isVisible: true }
};

export const checkoutChargeScalableStyle: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: true, isClickable: true },
    image: { isVisible: true },
    comparison: { isVisible: false },
    ids: { customerArticleNumber: true, articleNumber: true, ean: true },
    positionText: { isVisible: false },
    tags: { isVisible: true },
    icons: { isVisible: true },
    prices: {
        isVisible: true,
        uvp: { showUvpWithoutVat: true, showUvpWithVat: true },
        showSurcharges: true,
        showScalePrices: true
    },
    order: {
        quantityPicker: { isVisible: true, pickerDisabled: true, showCalculator: false },
        showAddToCart: false,
        showSecondaryButton: false,
        showPriceBadge: true,
        showBestPrice: true,
        showPackagingSize: true
    },
    availabilities: { isVisible: false, showPickupChannels: true },
    additionalLinks: { isVisible: false },
    information: { isVisible: true }
};

export const customLineItem: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: true, isClickable: false },
    image: { isVisible: true },
    comparison: { isVisible: false },
    ids: { customerArticleNumber: false, articleNumber: true, ean: true },
    positionText: { isVisible: true },
    tags: { isVisible: false },
    icons: { isVisible: false },
    prices: {
        isVisible: true,
        uvp: { showUvpWithoutVat: false, showUvpWithVat: false },
        showSurcharges: false,
        showScalePrices: true
    },
    order: {
        quantityPicker: { isVisible: true, pickerDisabled: false, showCalculator: false },
        showAddToCart: false,
        showSecondaryButton: false,
        showBestPrice: true,
        showPriceBadge: true
    },
    availabilities: { isVisible: false, showPickupChannels: false },
    additionalLinks: { isVisible: false },
    information: { isVisible: false }
};

export const customLineItemCheckout: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: true, isClickable: false },
    image: { isVisible: true },
    comparison: { isVisible: false },
    ids: { customerArticleNumber: false, articleNumber: true, ean: true },
    positionText: { isVisible: false },
    tags: { isVisible: false },
    icons: { isVisible: false },
    prices: {
        isVisible: true,
        uvp: { showUvpWithoutVat: false, showUvpWithVat: false },
        showSurcharges: false,
        showScalePrices: true
    },
    order: {
        quantityPicker: { isVisible: true, pickerDisabled: true, showCalculator: false },
        showAddToCart: false,
        showSecondaryButton: false,
        showBestPrice: true,
        showPriceBadge: true
    },
    availabilities: { isVisible: false, showPickupChannels: false },
    additionalLinks: { isVisible: false },
    information: { isVisible: false }
};

export const smartProductCard: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: true, isClickable: true },
    image: { isVisible: true },
    comparison: { isVisible: false },
    ids: { customerArticleNumber: false, articleNumber: true, ean: true },
    positionText: { isVisible: false },
    tags: { isVisible: true },
    icons: { isVisible: true },
    prices: {
        isVisible: true,
        uvp: { showUvpWithoutVat: true, showUvpWithVat: true },
        showSurcharges: false,
        showScalePrices: true
    },
    order: {
        quantityPicker: { isVisible: true, pickerDisabled: false, showCalculator: true },
        showAddToCart: true,
        showSecondaryButton: true,
        showBestPrice: true,
        showPriceBadge: false
    },
    availabilities: { isVisible: false, showPickupChannels: false },
    additionalLinks: { isVisible: false },
    information: { isVisible: false }
};

export const minimalSmartProductCard: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: true, isClickable: true },
    image: { isVisible: true },
    comparison: { isVisible: false },
    ids: { customerArticleNumber: false, articleNumber: true, ean: true },
    positionText: { isVisible: false },
    tags: { isVisible: true },
    icons: { isVisible: true },
    prices: {
        isVisible: false,
        uvp: { showUvpWithoutVat: false, showUvpWithVat: false },
        showSurcharges: false,
        showScalePrices: false
    },
    order: {
        quantityPicker: { isVisible: false, pickerDisabled: false, showCalculator: false },
        showAddToCart: true,
        showSecondaryButton: true,
        showPriceBadge: false,
        showPrices: false,
        showBestPrice: false
    },
    availabilities: { isVisible: false, showPickupChannels: false },
    additionalLinks: { isVisible: false },
    information: { isVisible: false }
};

export const crosssellingAccessoriesCard: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: true, isClickable: true },
    image: { isVisible: true },
    comparison: { isVisible: false },
    ids: { customerArticleNumber: false, articleNumber: true, ean: true },
    positionText: { isVisible: false },
    tags: { isVisible: false },
    icons: { isVisible: false },
    prices: {
        isVisible: false,
        uvp: { showUvpWithoutVat: false, showUvpWithVat: false },
        showSurcharges: false,
        showScalePrices: false
    },
    order: {
        quantityPicker: { isVisible: true, pickerDisabled: false, showCalculator: false },
        showAddToCart: true,
        showSecondaryButton: false,
        showPriceBadge: false,
        showPrices: false,
        showBestPrice: false
    },
    availabilities: { isVisible: false, showPickupChannels: false },
    additionalLinks: { isVisible: false },
    information: { isVisible: false }
};

export const mobileProductCard: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: true },
    image: { isVisible: true },
    comparison: { isVisible: false },
    ids: { customerArticleNumber: false, articleNumber: true, ean: true },
    positionText: { isVisible: false },
    tags: { isVisible: true },
    icons: { isVisible: true },
    prices: {
        isVisible: true,
        uvp: { showUvpWithoutVat: false, showUvpWithVat: false },
        showSurcharges: false,
        showScalePrices: true
    },
    order: {
        quantityPicker: { isVisible: true, pickerDisabled: false, showCalculator: false },
        showAddToCart: true,
        showSecondaryButton: false,
        showBestPrice: true,
        showPriceBadge: false
    },
    availabilities: { isVisible: true, showPickupChannels: false },
    additionalLinks: { isVisible: false },
    information: { isVisible: false }
};

export const buyBox: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: false, isClickable: true },
    image: { isVisible: false },
    comparison: { isVisible: true },
    ids: { customerArticleNumber: false, articleNumber: false, ean: false },
    positionText: { isVisible: true },
    tags: { isVisible: false },
    icons: { isVisible: true },
    prices: {
        isVisible: true,
        uvp: { showUvpWithoutVat: true, showUvpWithVat: true },
        showSurcharges: true,
        showScalePrices: true
    },
    order: {
        quantityPicker: { isVisible: true, pickerDisabled: false, showCalculator: true },
        showAddToCart: true,
        showSecondaryButton: true,
        showPriceBadge: false,
        showBestPrice: true,
        showPackagingSize: true
    },
    availabilities: { isVisible: true, showPickupChannels: true },
    additionalLinks: { isVisible: false },
    information: { isVisible: true }
};

export const smartProductList: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: true, isClickable: true },
    image: { isVisible: true },
    comparison: { isVisible: true },
    ids: { customerArticleNumber: false, articleNumber: true, ean: true },
    positionText: { isVisible: false },
    tags: { isVisible: false },
    icons: { isVisible: false },
    prices: {
        isVisible: true,
        uvp: { showUvpWithoutVat: true, showUvpWithVat: true },
        showSurcharges: false,
        showScalePrices: true
    },
    order: {
        quantityPicker: { isVisible: true, pickerDisabled: false, showCalculator: true },
        showAddToCart: true,
        showSecondaryButton: true,
        showBestPrice: true,
        showPriceBadge: false
    },
    availabilities: { isVisible: true, showPickupChannels: false },
    additionalLinks: { isVisible: false },
    information: { isVisible: false }
};

export const offerLineItem: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: true, isClickable: true },
    image: { isVisible: true },
    comparison: { isVisible: false },
    ids: { customerArticleNumber: false, articleNumber: true, ean: true },
    positionText: { isVisible: false },
    tags: { isVisible: false },
    icons: { isVisible: false },
    prices: {
        isVisible: true,
        uvp: { showUvpWithoutVat: false, showUvpWithVat: false },
        showSurcharges: true,
        showScalePrices: true
    },
    order: {
        quantityPicker: { isVisible: true, pickerDisabled: false, showCalculator: false },
        showAddToCart: false,
        showSecondaryButton: false,
        showPriceBadge: true,
        showBestPrice: true,
        showPackagingSize: true
    },
    availabilities: { isVisible: true, showPickupChannels: true },
    additionalLinks: { isVisible: false },
    information: { isVisible: true }
};

export const praemienShop: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: true, isClickable: true },
    image: { isVisible: true },
    comparison: { isVisible: false },
    ids: { customerArticleNumber: false, articleNumber: true, ean: false },
    positionText: { isVisible: false },
    tags: { isVisible: false },
    icons: { isVisible: false },
    prices: {
        isVisible: true,
        uvp: { showUvpWithoutVat: false, showUvpWithVat: false },
        showSurcharges: false,
        showScalePrices: true
    },
    order: {
        quantityPicker: { isVisible: true, pickerDisabled: false, showCalculator: false },
        showAddToCart: false,
        showSecondaryButton: false,
        showPrices: false,
        showBestPrice: true,
        showPriceBadge: false
    },
    availabilities: { isVisible: true, showPickupChannels: false },
    additionalLinks: { isVisible: false },
    information: { isVisible: false }
};

export const buyBoxPraemienShop: ScalableProductCARD_STYLE_TYPE = {
    name: { isVisible: true, isClickable: false },
    image: { isVisible: false },
    comparison: { isVisible: false },
    ids: { customerArticleNumber: false, articleNumber: true, ean: false },
    positionText: { isVisible: false },
    tags: { isVisible: false },
    icons: { isVisible: false },
    prices: {
        isVisible: true,
        uvp: { showUvpWithoutVat: false, showUvpWithVat: false },
        showSurcharges: false,
        showScalePrices: true
    },
    order: {
        quantityPicker: { isVisible: true, pickerDisabled: false, showCalculator: false },
        showAddToCart: false,
        showSecondaryButton: false,
        showPrices: false,
        showBestPrice: true,
        showPriceBadge: false
    },
    availabilities: { isVisible: true, showPickupChannels: false },
    additionalLinks: { isVisible: false },
    information: { isVisible: false }
};
